import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import EditMediaContainer from './EditMediaContainer';

const EditMedia = ({ testId = '' }) => {
  const { id } = useParams();
  return <EditMediaContainer id={id} testId={testId} />;
};

export default EditMedia;

EditMedia.propTypes = {
  /**
   * Page test id
   */
  testId: PropTypes.string,
};
